import React from 'react';
import { IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import './GameHeader.css';
import { useSidebar } from '../GameContainer/SidebarContext.tsx';
import { useNotification } from '../GameContainer/NotificationContext.tsx';

interface BaseHeaderProps {
  title: React.ReactNode;
  rightContent?: React.ReactNode;
  isArchive?: boolean;
}

export default function BaseHeader(props: BaseHeaderProps) {
  const { setIsSidebarOpen } = useSidebar();
  const { hasAnyNotification } = useNotification();
  
  return (
    <div className={['gameHeader', props.isArchive ? 'archivedGameHeader' : null].join(' ')}>
      <div className='gameHeaderLeftGroup'>
        <IconButton 
          onClick={() => setIsSidebarOpen(true)}
          size="small"
          sx={{ color: 'inherit', position: 'relative' }}
        >
          <MenuIcon />
          {hasAnyNotification && (
            <span className="notification-dot" />
          )}
        </IconButton>
        <span className='gameTitleSmall'>
          {props.title}
        </span>
      </div>

      <div className='gameHeaderRightGroup'>
        {props.rightContent}
      </div>
    </div>
  );
} 